import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination, Autoplay]);

export default Swiper;
